import axios from 'axios';
import apiUrl from './index';

const source = axios.CancelToken.source();
let config = { cancelToken: source.token };

export async function getFeatureFlags() {
	const satelliteUrl = window.localStorage.getItem('satelliteUrl');
	const hostUrl = satelliteUrl ? satelliteUrl : process.env.REACT_APP_ENGINE_HOST_URL;
	let requestUrl = hostUrl + apiUrl.path.featureFlags;

	return axios(
		{
			method: 'get',
			url: requestUrl,
		},
		config,
	);
}